import { render, staticRenderFns } from "./ProtocoloVistaCc.vue?vue&type=template&id=e7e86918&"
import script from "./ProtocoloVistaCc.vue?vue&type=script&lang=js&"
export * from "./ProtocoloVistaCc.vue?vue&type=script&lang=js&"
import style0 from "./ProtocoloVistaCc.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VSpacer})
